import React from "react";
import MStack from '@mui/material/Stack';

const Stack = React.forwardRef((props, ref) => {
    return (
        <MStack ref={ref} {...props} />
    )
});

Stack.displayName = "Stack";

export default React.memo(Stack);
